import { Injectable } from '@angular/core';
import { ProxyService } from '../proxy/ProxyService';

@Injectable({
    providedIn: 'root'
})
export class ZipValidationService {
    public static $name: string = 'zipValidationService';

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getZipValidator(countryId: number): angular.IPromise<CASLink.Infrastructure.Ui.ViewModel.ZipValidationViewModel> {
        return this.proxyService.request({
            endPoint: 'zipValidator',
            queryParams: {
                countryId: countryId
            },
            route: 'getZipValidatorForCountry'
        }).as<CASLink.Infrastructure.Ui.ViewModel.ZipValidationViewModel>();
    }
}
